import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getFeatureTableTooltipKey } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableUserIcon = ({
  freeUserAccess,
  productLine,
  showTooltip = true,
  canViewNewSeats = false
}) => {
  const tooltipKey = getFeatureTableTooltipKey(canViewNewSeats, freeUserAccess, productLine);
  return /*#__PURE__*/_jsx("p", {
    className: "m-all-0",
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: !showTooltip,
      placement: "top",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: tooltipKey
      }),
      children: /*#__PURE__*/_jsx("span", {
        tabIndex: -1,
        children: /*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-1",
          name: "contacts",
          "data-test-id": "user-icon"
        })
      })
    })
  });
};
export default FeatureTableUserIcon;